document.addEventListener("DOMContentLoaded", function () {
  const vapidPublicKey =
    "BJyaHjbTlsExHwb0mNHA_bCI-192oxPzOaC0DzXwr-aif_aYR2nHDGBHe--fpet9HPVPbx98yKuMnlg8W0a8_Zg";
  const convertedVapidKey = _urlBase64ToUint8Array(vapidPublicKey);

  function registerServiceWorker() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("./registerServiceWorker.js?v=8")
        .then(function (reg) {
          // console.log("Service worker registered:", reg);

          reg.pushManager.getSubscription().then(function (sub) {
            if (!sub) {
              subscribeUser(reg);
            } else {
              const p256dhKey = arrayBufferToBase64(sub.getKey("p256dh"));
              const authKey = arrayBufferToBase64(sub.getKey("auth"));

              if (p256dhKey && authKey) {
                const enhancedSub = {
                  ...sub,
                  endpoint: sub.endpoint,
                  keys: {
                    p256dh: p256dhKey,
                    auth: authKey,
                  },
                };
                saveSubscriptionObject(enhancedSub);
                // console.log("Endpoint:", sub.endpoint);
                // console.log("p256DH Key:", p256dhKey);
                // console.log("Auth Key:", authKey);
              }
            }
          });
        })
        .catch(function (error) {
          console.log("Service worker registration failed:", error);
        });
    } else {
      console.log("Service workers are not supported in this browser.");
    }
  }

  function arrayBufferToBase64(buffer) {
    const uint8Array = new Uint8Array(buffer);
    let binaryString = "";
    for (let i = 0; i < uint8Array.byteLength; i++) {
      binaryString += String.fromCharCode(uint8Array[i]);
    }
    return window.btoa(binaryString);
  }

  function subscribeUser(reg) {
    reg.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey,
      })
      .then(function (sub) {
        // console.log("Subscription object:", sub);

        const p256dhKey = arrayBufferToBase64(sub.getKey("p256dh"));
        const authKey = arrayBufferToBase64(sub.getKey("auth"));

        if (p256dhKey && authKey) {
          // console.log("p256DH Key:", p256dhKey);
          // console.log("Auth Key:", authKey);

          const enhancedSub = {
            ...sub,
            endpoint: sub.endpoint,
            keys: {
              p256dh: p256dhKey,
              auth: authKey,
            },
          };

          saveSubscriptionObject(enhancedSub);
        } else {
          console.warn("p256DH and auth keys are not available.");
        }
      })
      .catch(function (e) {
        if (Notification.permission === "denied") {
          console.warn("Permission for notifications was denied.");
        } else {
          console.error("Unable to subscribe to push", e);
        }
      });
  }

  function saveSubscriptionObject(sub) {
    let data = {};
    data = JSON.stringify({
      endpoint: sub.endpoint,
      p256DH: sub.keys.p256dh,
      auth: sub.keys.auth,
    });
    localStorage.setItem("PWAData", data);
  }

  function _urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  registerServiceWorker();
});
